module.exports = require("@nextcloud/axios");